export * from "./heading.component";
export * from "./heading.types";
